import { NodeType } from '../../../enums/NodeType';
import { Role } from '../../../enums/Role';
import { GetPermissionFn, Permission } from './types';
import { disabledForEditMode } from '../../../utils/editModeUtils';
import { getLockedNodeTypes } from '../../../utils';

export const getSchemaPermission: GetPermissionFn = ({
  isWorkspaceOwner,
  isWorkspaceDataManager,
  workspace,
  hasRole,
  schema,
  data,
  selectedWorkspace
}): Permission => {
  if (hasRole(Role.planningReadonly)) {
    return { canView: true, canEdit: false };
  }

  if (!schema?.props) {
    return { canView: true, canEdit: false };
  }

  if (disabledForEditMode(data, selectedWorkspace).disabled) {
    return { canView: true, canEdit: false };
  }

  if (schema?.labels.includes(NodeType.WorkspaceSchema)) {
    if (hasRole(Role.admin) || isWorkspaceOwner) {
      return { canView: true, canEdit: true };
    } else {
      return { canView: true, canEdit: false };
    }
  }

  const type = schema?.props?.type;

  const lockedNodeTypes = getLockedNodeTypes(workspace);
  if (lockedNodeTypes.includes(type)) {
    return { canView: true, canEdit: false };
  }

  if (type != NodeType.Item) {
    if (
      schema.props?.isManaged &&
      hasRole(Role.questionManager, Role.admin, Role.backtagAdmin)
    ) {
      return { canView: true, canEdit: true };
    }
    if (
      schema.isInherited ||
      schema.isSystemSchema ||
      (!isWorkspaceOwner && !isWorkspaceDataManager)
    ) {
      return { canView: true, canEdit: false };
    }
    return { canView: true, canEdit: true };
  } else {
    if (!workspace.props.allowAddNewItems) {
      return { canView: true, canEdit: false };
    }

    if (schema.isSystemSchema && !schema.props.allowAddDataWithBaseSchema) {
      return { canView: true, canEdit: false };
    }
    return { canView: true, canEdit: true };
  }
};
